<template>
  <div>
    <div class="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-5">
    <!--Card 1-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Clientes</div>
        <h3 class="text-gray-700 text-base">
         {{clientes}}
        </h3>
        
      </div>
    </div>
    <!--Card 2-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Entradas</div>
        <h4 class="text-gray-700 text-base">
         {{maquinarias}}
        </h4>
      </div>
    </div>

    <!--Card 3-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Ventas Negativas</div>
        <p class="text-gray-700 text-base">
            {{despachos}}
        </p>
      </div>
    </div>
    <!--Card 4-->
    <div class="rounded overflow-hidden shadow-lg">
      <div class="px-6 py-4">
        <div class="font-bold text-xl mb-2">Total Facturado</div>
        <p class="text-gray-700 text-base">
            {{total}}
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Layout from '@/Shared/Layout'


export default {
  metaInfo: { title: 'Dashboard' },
  components: {
  },
  layout: Layout,
  props: {
    clientes: Number,
    maquinarias: Number,
    despachos: Number,
    total: Number,

  },
  data(){
    return {
      datacollection: null
    }
  }, mounted () {
    this.fillData()
  },
  methods: {

    
  }
}
</script>